module.exports = __webpack_public_path__ + "img/9.3321a545.png";